var _effectorFileName = "/builds/gmini/front-ui-kit/src/icons/Angle.tsx";
import { jsx as _jsx } from "react/jsx-runtime";

/**
 * Иконка Angle
 */
export const Angle = ({
  color = '#00003D',
  ...other
}) => /*#__PURE__*/_jsx("svg", {
  width: "100%",
  height: "100%",
  viewBox: "0 0 8 5",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ...other,
  children: /*#__PURE__*/_jsx("path", {
    d: "M6.77405 0.209386L3.99642 2.98701L1.21879 0.209386C1.08504 0.0753345 0.903458 0 0.714094 0C0.52473 0 0.343146 0.0753345 0.209396 0.209386C-0.0697987 0.48858 -0.0697987 0.939587 0.209396 1.21878L3.4953 4.50469C3.7745 4.78388 4.2255 4.78388 4.5047 4.50469L7.7906 1.21878C8.0698 0.939587 8.0698 0.48858 7.7906 0.209386C7.51141 -0.0626501 7.05324 -0.069809 6.77405 0.209386Z",
    fill: color
  })
});